import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { ActionApiCongigs, Actions, Result } from '../_models';
import { URLPARAMS } from '../_models/urlparams';


@Injectable({
  providedIn: 'root'
})
export class ActionService {
  private ActionSubject: BehaviorSubject<Actions>;
  public Action: Observable<Actions>;
  
  constructor(
    private http: HttpClient
  ) {
    this.ActionSubject = new BehaviorSubject<Actions>(JSON.parse(localStorage.getItem('action')));
    this.Action = this.ActionSubject.asObservable();
  }




  getAll(uId: string) {
   
    return this.http.get<Actions[]>(`${environment.apiUrl}/action/getActions?uid=${uId}`);
  }
  getAuthenticate(uId: string) {
    return this.http.get<Result>(`${environment.apiUrl}/trigger/getauthentication?uid=${uId}`);
  }
  AddUpdateAction(action: Actions) {
    return this.http.post<Result>(`${environment.apiUrl}/action/addupdateAction`, action);
  }
  getAction(actionID: string) {
    return this.http.get<Actions>(`${environment.apiUrl}/action/getAction?actionID=${actionID}`);
  }
  remove(aID: string) {
   
    return this.http.post<Result>(`${environment.apiUrl}/action/Removeaction?aID=${aID}`, aID);
  }
  AddUpdateActionApi(actionapiconfiq : ActionApiCongigs) {
    return this.http.post<Result>(`${environment.apiUrl}/action/addupdateactionapi`, actionapiconfiq);
  }
  //gettriggerapi
  getactionapi(uId: string, aId: string) {
    return this.http.get<ActionApiCongigs>(`${environment.apiUrl}/action/getactionapi?uid=${uId}&aid=${aId}`);
  }

  getAllURL(uId: string, aId: string) {
    return this.http.get<URLPARAMS[]>(`${environment.apiUrl}/action/getactionapiURLs?uid=${uId}&aid=${aId}`);
  }
  getAllBody(uId: string, aId: string) {
    return this.http.get<URLPARAMS[]>(`${environment.apiUrl}/action/getactionapiBody?uid=${uId}&aid=${aId}`);
  }
  getAllHeader(uId: string, aId: string) {
    return this.http.get<URLPARAMS[]>(`${environment.apiUrl}/action/getactionapiheader?uid=${uId}&aid=${aId}`);
  }
}
